import { Box, useTheme } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import React, { memo } from "react";

interface ProcessingHeaderProps {
    error: boolean;
    successLabel: string;
    errorLabel: string;
}

const ProcessingHeader = ({ error, errorLabel, successLabel }: ProcessingHeaderProps) => {
    const theme = useTheme();

    return (
        <Box
            display="flex"
            alignItems="center"
            fontWeight="fontWeightBold"
            color={error ? theme.palette.error.main : theme.palette.success.main}>
            <Box display="flex" pr={2}>
                {error ? <ErrorIcon color="inherit" /> : <CheckCircleIcon color="inherit" />}
            </Box>
            <Box>{error ? errorLabel : successLabel}</Box>
        </Box>
    );
};

export default memo(ProcessingHeader);
